export const getDefaultState = () => {
	return {
		requestType: {},
		generalData: {},
		isLoadedGeneralData: false
	};
};

export default getDefaultState();
